function scrollToTodayIfNeeded() {
  const gantt = window.to_use_react_gantt;
  if (gantt.firstScrollToday) {
    gantt.scrollToTodayAtChart();
    gantt.firstScrollToday = false;
  }
}

export { scrollToTodayIfNeeded };
